import { render, staticRenderFns } from "./googleAds.vue?vue&type=template&id=2487f63f&"
import script from "./googleAds.vue?vue&type=script&lang=js&"
export * from "./googleAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports